import React from 'react';
import loadable from '@loadable/component';

export default loadable(
    () =>
        import(
            /* webpackChunkName: "LazyCSPLandingChunk", webpackPreload: true */ './CSPLandingConnect'
        ),
    {
        fallback: <div>Loading...</div>,
    }
);
